module.exports = __webpack_public_path__ + "media/images/pages/sample_brands/brand-airbnb-1d4889702e4fa043ca4cb5c69ed1699a.png";